/* @flow */

import React from 'react';
import { withRouter, Switch, Route } from 'react-router';
import { Menu, Button, Icon } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import AddDocumentButton from './components/AddDocumentButton';

type Props = {
  user: string,
  isSaving: boolean,
  onAddDocument: resource => void,
  onSave: () => void,
};

const styles = {
  items: {
    marginLeft: '2em',
  },
};

const Navigation = ({ user, isSaving, onAddDocument, onSave }: Props) => {
  return (
    <Menu attached="top" secondary pointing className="segment actions">
      <Menu.Item>
        <Button
          basic
          as="a"
          href="/mc/my-space"
          labelPosition="left"
          content="Retour à la liste"
          icon="chevron circle left"
        />
      </Menu.Item>
      <NavLink
        to="/documents"
        className="ui link item"
        activeClassName="active"
        style={styles.items}
      >
        Documents
      </NavLink>
      <NavLink to="/events" className="ui link item" activeClassName="active">
        Evènements
      </NavLink>
      <Menu.Menu position="right">
        <Menu.Item>
          <Switch>
            <Route exact path="/documents">
              <AddDocumentButton isSaving={isSaving} onAdd={onAddDocument} />
            </Route>
            <Route exact path="/events">
              <a
                href={`/mc/my-space/${user}/events/new`}
                className="ui basic labeled icon button"
              >
                <Icon name="add" />
                Ajouter
              </a>
            </Route>
          </Switch>
        </Menu.Item>
        <Switch>
          <Route exact path="/documents">
            <Menu.Item>
              <Button
                type="button"
                primary
                loading={isSaving}
                onClick={onSave}
                icon="save"
                content="Enregistrer"
                labelPosition="right"
              />
            </Menu.Item>
          </Route>
        </Switch>
      </Menu.Menu>
    </Menu>
  );
};

export default withRouter(Navigation);



// WEBPACK FOOTER //
// ./src/modules/my-space/Navigation.js